import LocalDate from '@booking-services/localDate'

export default {
  monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  years: [...Array(20)].map((_, i) => {return Number(new LocalDate().getFullYear()) - i}),
}